import firebase from "firebase";
import { ACTIVE_ENVIRONMENT } from "../config/env/index";

const firebaseConfig = ACTIVE_ENVIRONMENT.config;

firebase.initializeApp(firebaseConfig);

export default firebase;
